import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Button = lib.styled.button`
    .icon {
        font-size: 15px !important;
        color: ${colors.lightBlue03} !important;

        div {
            display: flex;
            height: fit-content;
        }
    }
`;
